import React from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as down_arrow_svg } from '../../../assets/Down.svg';
import { ReactComponent as right_arrow_svg } from '../../../assets/Right.svg';
import { ReactComponent as plus_svg } from '../../../assets/Plus.svg';
import { Tooltip } from 'antd';
import Icon from '@ant-design/icons';

export function TitleAction({
  menuKey,
  title,
  arrowAction,
  plusAction,
  showDownArrow,
  titleAction = null,
  plusTooltip,
  itemType,
  itemUUID,
  itemLabel,
  itemLeftMenuName,
}) {
  const DownArrowIcon = (props) => <Icon component={down_arrow_svg} />;
  const RightArrowIcon = (props) => <Icon component={right_arrow_svg} />;
  const PlusIcon = (props) => <Icon component={plus_svg} />;

  let titleProps = {};
  if (titleAction) {
    titleProps = {
      onClick: titleAction,
    };
  }

  return (
    <div style={{ width: '100%', height: '100%' }}>
      {arrowAction && (
        <div onClick={arrowAction}>
          {showDownArrow && <DownArrowIcon />}
          {!showDownArrow && <RightArrowIcon />}
        </div>
      )}
      <div style={{ width: '100%', height: '100%' }} {...titleProps}>
        {title}
      </div>
      {plusAction && (
        <Tooltip title={plusTooltip ? plusTooltip : ''}>
          {menuKey !== 'filter-profiles' ? (
            <div onClick={plusAction}>
              <Link
                to={
                  itemType === 'recipe' || !itemType
                    ? // ? `/explore/${itemLabel ?? menuKey}`
                      `/explore/${itemType ? itemUUID : menuKey}` +
                      `?left_menu_name=${itemLeftMenuName ?? itemLabel}`
                    : `/explore/query-builder/?query=${itemUUID}` +
                      (itemLeftMenuName
                        ? `&left_menu_name=${itemLeftMenuName}`
                        : '')
                }
              >
                <PlusIcon />
              </Link>
            </div>
          ) : (
            <div onClick={plusAction}>
              <PlusIcon />
            </div>
          )}
        </Tooltip>
      )}
    </div>
  );
}
